export const THRESHOLD_PLOT_COLOR_NAMES: Record<string, string> = {
  '#ef4444': 'Red',
  '#f97316': 'Orange',
  '#d97706': 'Amber',
  '#e11d48': 'Rose',
  '#db2777': 'Pink',
  '#3b82f6': 'Blue',
  '#22c55e': 'Green',
  '#14b8a6': 'Teal',
  '#8b5cf6': 'Purple',
};

export const THRESHOLD_PLOT_COLORS = Object.keys(THRESHOLD_PLOT_COLOR_NAMES);
